import { z } from 'zod';
import { compareDates } from '../time/calendarDate.js';
export const idSchema = z.uuid();
export const calendarDateSchema = z.iso.date();
export const nameSchema = z.string().trim().min(1, 'Name is required').max(80);
export const justificationSchema = z.string().trim().min(1, 'A justification is required').max(500);
export const dateRangeSchema = z
    .strictObject({
    start: calendarDateSchema,
    end: calendarDateSchema,
})
    .refine((range) => compareDates(range.start, range.end) < 0, {
    error: 'The departure date must be after the arrival date',
    path: ['end'],
});
export const dateRangeListSchema = z.array(dateRangeSchema).min(1, 'At least one date range');
/** Machine-readable failure codes shared by the API and the client. */
export const API_ERROR_CODES = [
    'validation_error',
    'unauthorized',
    'forbidden',
    'not_found',
    'conflict',
    'unprocessable',
    'internal_error',
];
//# sourceMappingURL=common.js.map